import { PreviewChartContext } from '@repo/utils';
import c from 'classnames';
import styles from './PreviewChart.module.css';

const FRAME_BOTTOM = 16;

type Props = {
  context: PreviewChartContext;
  className?: string;
};

export default function PreviewChart({ context, className }: Props) {
  return (
    <svg
      viewBox='0 0 30 16'
      className={c(styles.chart, className)}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d={`M0.5 0 L0.5 ${FRAME_BOTTOM - 0.5} L30 ${FRAME_BOTTOM - 0.5}`}
        className={styles.frame}
      />
      <polyline points={context.linePoints} className={styles.line} />
      {context.points.map((p, i) => (
        <circle
          key={i}
          cx={p.x}
          cy={p.y}
          r={2}
          className={c(styles.dot, styles[p.evaluation_color])}
        />
      ))}
    </svg>
  );
}
